import PropTypes from 'prop-types'
import { FormFeedback, Input, Label } from "reactstrap"
import React from "react";
import labelConstant from 'constants/label';
const Duration = ({ validation }) => {

    return (
        <div className="mb-3">
            <Label className="form-label">{labelConstant.DURATION}(in hours)<span className="text-danger">*</span></Label>
            <Input
                name="duration"
                className="form-control"
                placeholder={"Enter " + labelConstant.DURATION + " in hours"}
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.duration || ""}
                invalid={
                    validation.touched.duration && validation.errors.duration ? true : false
                }
            />
            {validation.touched.duration && validation.errors.duration ? (
                <FormFeedback type="invalid">{validation.errors.duration}</FormFeedback>
            ) : null}
        </div>

    )
}

Duration.propTypes = {
    validation: PropTypes.object,
}

export default Duration
